export type ProgramCatalogFilters = {
	search: string
	lifecycle: '' | 'DRAFT' | 'PUBLISHED' | 'ARCHIVED'
	sort: 'id' | 'name' | 'created_at' | 'updated_at' | 'lifecycle'
	direction: 'asc' | 'desc'
	limit: number
}

export const defaultProgramCatalogFilters: ProgramCatalogFilters = {
	search: '',
	lifecycle: '',
	sort: 'updated_at',
	direction: 'desc',
	limit: 25,
}

const validSort = new Set<ProgramCatalogFilters['sort']>([
	'id',
	'name',
	'created_at',
	'updated_at',
	'lifecycle',
])
const validLifecycle = new Set<ProgramCatalogFilters['lifecycle']>([
	'',
	'DRAFT',
	'PUBLISHED',
	'ARCHIVED',
])

export const parseProgramCatalogFilters = (search: string): ProgramCatalogFilters => {
	const params = new URLSearchParams(search)
	const sort = params.get('sort') as ProgramCatalogFilters['sort'] | null
	const lifecycle = (params.get('lifecycle') ?? '') as ProgramCatalogFilters['lifecycle']
	const direction = params.get('direction')
	const parsedLimit = Number(params.get('limit'))
	return {
		search: params.get('search') ?? '',
		lifecycle: validLifecycle.has(lifecycle) ? lifecycle : '',
		sort: sort && validSort.has(sort) ? sort : defaultProgramCatalogFilters.sort,
		direction:
			direction === 'asc' || direction === 'desc'
				? direction
				: defaultProgramCatalogFilters.direction,
		limit:
			Number.isInteger(parsedLimit) && parsedLimit >= 10 && parsedLimit <= 100
				? parsedLimit
				: defaultProgramCatalogFilters.limit,
	}
}

export const serializeProgramCatalogFilters = (filters: ProgramCatalogFilters) => {
	const params = new URLSearchParams()
	if (filters.search.trim()) params.set('search', filters.search.trim())
	if (filters.lifecycle) params.set('lifecycle', filters.lifecycle)
	if (filters.sort !== defaultProgramCatalogFilters.sort) params.set('sort', filters.sort)
	if (filters.direction !== defaultProgramCatalogFilters.direction) {
		params.set('direction', filters.direction)
	}
	if (filters.limit !== defaultProgramCatalogFilters.limit) params.set('limit', String(filters.limit))
	const value = params.toString()
	return value ? `?${value}` : ''
}
